import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from 'react-helmet-async';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Firebase認証が完了したら描画
onAuthStateChanged(auth, () => {
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  );
});

reportWebVitals();
